// extracted by css-extract-rspack-plugin
var _1 = "y4r8cCV6CsQCE_yC";
export { _1 as "offerDescription" }
// extracted by css-extract-rspack-plugin
var _1 = "y4r8cCV6CsQCE_yC";
export { _1 as "offerDescription" }
